import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  originalPrice: number;
  salePrice: number;
  currency?: string;
}
export function PriceDisplay({
  originalPrice,
  salePrice,
  currency = 'ARS'
}: PriceDisplayProps) {
  const [currencySymbol, setCurrencySymbol] = useState('$');
  useEffect(() => {
    const locale = navigator.language || 'es-AR';
    // Map locale to currency symbol
    const symbolMap: {
      [key: string]: string;
    } = {
      'en-US': '$',
      'en-GB': '£',
      'es-ES': '€',
      'es-AR': '$',
      'es-MX': '$',
      'pt-BR': 'R$'
    };
    // Get symbol based on locale or default to $
    const symbol = symbolMap[locale] || symbolMap[locale.split('-')[0]] || '$';
    setCurrencySymbol(symbol);
  }, []);
  const formatPrice = (price: number) => {
    return price.toLocaleString('es-AR');
  };
  return <div className="text-center" data-id="element-93">
      <div className="mb-3" data-id="element-94">
        <span className="font-heading text-2xl md:text-3xl text-textLight line-through opacity-70" data-id="element-95">
          {currencySymbol}
          {formatPrice(originalPrice)} {currency}
        </span>
      </div>
      <div className="flex items-center justify-center gap-3" data-id="element-96">
        <span className="font-heading font-bold text-5xl md:text-7xl text-primary drop-shadow-sm" data-id="element-97">
          {currencySymbol}
          {formatPrice(salePrice)}
        </span>
        <div className="flex flex-col items-start" data-id="element-98">
          <span className="font-body text-xl text-textDark font-bold" data-id="element-99">
            {currency}
          </span>
          <span className="font-body font-bold text-xs tracking-wider text-white bg-urgency px-3 py-1 rounded-full mt-1 shadow-sm" data-id="element-100">
            OFERTA
          </span>
        </div>
      </div>
    </div>;
}